import { createSpotlight } from '@mantine/spotlight';

export const [searchStore, searchSpotlight] = createSpotlight();
